const lbaTabs = angular.module('app.lbaTabs', []);

lbaTabs.controller('lbaTabsCtrl', require('./lbaTabsCtrl'));
lbaTabs.directive('lbaTabs', require('./lbaTabsDir'));

export default lbaTabs;



// WEBPACK FOOTER //
// ./src/components/lbaTabs/index.js